import useAppSelector from "@/core/helpers/useAppSelector";
import { personalDataSelector } from "@/domains/createCharacter/slice";
import CreateCharacterUserInfo from "@/domains/createCharacter/components/CreateCharacterUserInfo";

export default function CreateCharacterUserInfoContainer() {
  const personalData = useAppSelector(personalDataSelector);

  return <CreateCharacterUserInfo {...personalData} />;
}
